import * as types from '../../actions/actionTypes';

const defaultState = {
  data: null,
  status: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCH_DISTRIBUTION_CODE:
      return { ...state, status: null };
    case types.FETCH_DISTRIBUTION_CODE_DONE:
      return { ...state, status: true, data: action.data };
    case types.FETCH_DISTRIBUTION_CODE_FAIL:
      return { ...state, status: false, data: action.data };
    default:
      return state;
  }
};
